export default {
  courseSubjectList: [],
  subjectListNotInCourse: [],
  courseDetail: {},
  subjectDetail: {},
  chapterDetail: {},
  courseList: [],
  chapterList: [],
  examList: [],
  sheetList: [],
  chaperSheetList: [],
  examDetail: {},
  lecture_videoList: [],
  lecture_videoDetails: {},
  quiz_title: '',
  question: {},
  quizDetail: {},
  quizDetailForPage: {},
  questionList: [],
  uploadPercentage: 0
}
